
import React, { FunctionComponent, useState, useEffect } from "react";
import { checkSpecialCharacters } from 'src/utils/validationUtils';
import { TextArea } from "@scuf/common";
import '../ReviewerCheckList.scss'

interface ITextBoxOperation {
    actionResponse?: any;
    orguserId?: string;
    handleText: Function;
    labelId: number
}
export const TextBoxOperation: FunctionComponent<ITextBoxOperation> = (props) => {
    const [textBoxValue, setTextBoxValue] = useState("");
    const [validationError, setValidationError] = useState<boolean>(false);

    const handleTextbox = (value: any) => {
        if(checkSpecialCharacters(value)) {
            setValidationError(true);
        } else {
            setValidationError(false);
            setTextBoxValue(value)
            props.handleText(value, props.labelId)
        }
    }

    return (
        <>
            <label className="label">
                {/* Remarks{" "} */}
                {/* {showLableBardge && remark === "" ? (
              <Badge empty={true} color="red" />
            ) : (
              ""
            )} */}
            </label>

            <TextArea
                onChange={(value: any) => handleTextbox(value)}
                className="textarea-wrapper textarea-fi accept-gap"
                fluid={true}
                rows={1}
                value={textBoxValue}
            />
            {validationError && <div className="action--error-text">Special characters not allowed.</div>}
        </>
    );
};
